import { type SkillResource } from '@/features/iam/api/resources/skill'
import { type SkillTagResource } from '@/features/iam/api/resources/skill-tag'
import { type SkillProps } from '@/features/iam/skills/Skill'
import { type SkillTagProps } from '@/features/iam/skills/SkillTag'
import { maybeParseDate } from '@/utils/date-util'

export function mapSkillResourceToProps(
  resource: SkillResource,
): Partial<SkillProps> {
  return {
    id: resource.id,
    name: resource.name,
    workspaceId: resource.workspace_id,
    description: resource.description || '',
    dateCreated: maybeParseDate(resource.date_created),
    dateModified: maybeParseDate(resource.date_modified),
    tags: resource.tags?.map(mapSkillTagResourceToProps),
  }
}

export function mapSkillTagResourceToProps(
  resource: SkillTagResource,
): Partial<SkillTagProps> {
  return {
    id: resource.id,
    label: resource.label,
    workspaceId: resource.workspace_id,
    color: resource.color,
  }
}
